@if (isLoading) {
  <div class="loader-overlay" role="status" aria-live="polite">
    <div class="heart-wrapper" aria-hidden="true">
      <svg class="heart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          class="heart-shape"
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                 2 6 4 4 6.5 4c1.74 0 3.41 1 4.04 2.36C11.17 5 
                 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 
                 6.86-8.55 11.54L12 21.35z"
        />
        <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
      </svg>
    </div>
    <p class="loader-text mt-3 fw-semibold text-dark">Verifying OTP...</p>
  </div>
}

@if (!isLoading) {
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5">
        <div class="card booking-card">
          <div
            class="card-header booking-card__header text-center justify-content-center flex-column pb-3"
          >
            <div class="booking-card__eyebrow">Recovery Verification</div>
            <h2 class="sub-title mb-0 fs-3">Enter OTP Code</h2>
          </div>

          <div class="card-body p-4">
            <!-- Prominent Error Alert Banner -->
            @if (errorMessage()) {
              <div
                class="alert alert-danger d-flex align-items-start mb-4 p-3 rounded-3 shadow-sm border-danger border-start border-4"
                role="alert"
              >
                <i
                  class="bi bi-exclamation-octagon-fill fs-4 me-3 text-danger flex-shrink-0 mt-1"
                ></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-danger">Verification Failed</div>
                  <div class="small text-dark mt-1">{{ errorMessage() }}</div>
                </div>
                <button
                  type="button"
                  class="btn-close ms-2"
                  (click)="errorMessage.set(null)"
                  aria-label="Close error message"
                ></button>
              </div>
            }

            <p class="text-muted small text-center mb-4">
              Enter the 5-digit verification code sent to your email.
            </p>

            <form [formGroup]="form" (ngSubmit)="submitOtp()">
              <!-- OTP -->
              <div class="mb-4">
                <label for="otp" class="form-label text-center d-block">Verification Code</label>
                <input
                  id="otp"
                  type="text"
                  class="form-control text-center fs-3 fw-bold letter-spacing"
                  maxlength="5"
                  formControlName="otp"
                  placeholder="00000"
                />

                @if (form.get('otp')?.touched && form.get('otp')?.invalid) {
                  <div class="text-danger small mt-1 text-center">OTP must be 5 digits.</div>
                }
              </div>

              <!-- Submit -->
              <div class="d-grid mt-4">
                <button
                  class="btn btn-primary py-2"
                  type="submit"
                  [disabled]="isLoading || form.invalid"
                >
                  <i class="bi bi-shield-check me-1"></i> Verify OTP
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
}
